import { render, staticRenderFns } from "./MicroBase.vue?vue&type=template&id=18715486&scoped=true"
import script from "./MicroBase.vue?vue&type=script&lang=js"
export * from "./MicroBase.vue?vue&type=script&lang=js"
import style0 from "./MicroBase.vue?vue&type=style&index=0&id=18715486&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18715486",
  null
  
)

export default component.exports